import { useTranslation } from "react-i18next";
import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";

import styles from "./TableHeaderCell.module.scss";

export const SimpleTableHeaderCell: React.FC<{ tableName: string; params: GridColumnHeaderParams }> = ({
  tableName,
  params,
}) => {
  const { t } = useTranslation();

  return <p className={styles.title}>{t(`${tableName}.${params.field}`)}</p>;
};
